import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetLifeplaceLink,
	GetLifeplaceLinkModel,
	GetLifeplaceLinkParams,
} from 'domain/usecases/private/lifeplace/get-lifeplace-link';

export class RemoteGetLifeplaceLink implements GetLifeplaceLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetLifeplaceLinkModel>,
	) {}

	async get(params: GetLifeplaceLinkParams): Promise<GetLifeplaceLinkModel> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
